import { Suspense } from "react";

import { Routes, Route } from "react-router";

import Embedded from "../Embedded";

import { AppRoutes } from "../../routes";

const Main = (): React.ReactElement => {
	return (
		<Suspense fallback={null}>
			<Routes>
				<Route path={AppRoutes.Embedded} element={<Embedded />} />
			</Routes>
		</Suspense>
	);
};

export default Main;
